import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/Donation';

import { DonationSettings } from '../model/skill';

const t = i18n(keyset);

export const defaultDonationSettings: DonationSettings = {
    defaultSum: '100',
    walletNumber: '',
} as const;

export const defaultSumValidator = (value: string) => {
    if (isNaN(Number(value))) {
        return t('sum-validate-is-number');
    }

    if (Number(value) > 15000) {
        return t('sum-validate-no-more-15k');
    }

    return '';
};

export const walletNumberValidator = (value: string) => {
    if (!/^41001[0-9]{6,15}$/.test(value)) {
        return t('wallet-validate-number');
    }

    return '';
};
